import React, { createContext, useState, useContext, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

export const AreasWrapper = ({ children }) => {
  return (
    <HeaderProvider>
      <HeaderLinksProvider>
        <FooterProvider>{children}</FooterProvider>
      </HeaderLinksProvider>
    </HeaderProvider>
  );
};
AreasWrapper.propTypes = { children: PropTypes.element.isRequired };

export const HeaderContext = createContext();
export const HeaderProvider = ({ children }) => <HeaderContext.Provider value={useState(null)}>{children}</HeaderContext.Provider>;
HeaderProvider.propTypes = { children: PropTypes.element.isRequired };
export const useHeader = initialHeader => {
  const [get, set] = useContext(HeaderContext);

  useLayoutEffect(() => {
    initialHeader && set(initialHeader);
    return () => set(null);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return [get, set];
};

export const FooterContext = createContext();
export const FooterProvider = ({ children }) => <FooterContext.Provider value={useState(null)}>{children}</FooterContext.Provider>;
FooterProvider.propTypes = { children: PropTypes.element.isRequired };
export const useFooter = initialFooter => {
  const [get, set] = useContext(FooterContext);

  useLayoutEffect(() => {
    initialFooter && set(initialFooter);
    return () => set(null);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return [get, set];
};

export const HeaderLinksContext = createContext();
export const HeaderLinksProvider = ({ children }) => (
  <HeaderLinksContext.Provider value={useState(null)}>{children}</HeaderLinksContext.Provider>
);
HeaderLinksContext.propTypes = { children: PropTypes.element.isRequired };
HeaderLinksProvider.propTypes = { children: PropTypes.element.isRequired };

export const useHeaderLinks = initialHeaderLinks => {
  const [get, set] = useContext(HeaderLinksContext);

  useLayoutEffect(() => {
    initialHeaderLinks && set(initialHeaderLinks);
    return () => set(null);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return [get, set];
};
